import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    confirmationMessage: (count: number, name: string) => string | React.ReactNode;
    deleteProjectConfirmButton: (count: number) => string;
    deleteProjectLoading: string;
    deleteProjectTitle: (count: number) => string;
    errorMessage: (count: number, name: string) => string;
    genericErrorMessage: string;
    successMessage: (count: number, name: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Confirmation message */
            confirmationMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number, name: string) => { const isSingular = count === 1; return __intl__.intl().formatMessage({ id: "useDeleteProjects.confirmationMessage.0?c=me47juibsq81", defaultMessage: "{isSingular, select, true {<jsx>Are you sure you want to delete <strong>\"{name}\"</strong>? Admins will be able to restore the project for 30 days. After 30 days, all associated media will be permanently deleted.</jsx>} other {<jsx>Are you sure you want to delete {count} Projects? All associated media will be permanently deleted. This cannot be undone.</jsx>}}" }, { isSingular: isSingular, jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), strong: (__children__: React.ReactNode) => <strong>{React.Children.toArray(__children__)}</strong>, name: name, count: count }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Delete project button label */
            deleteProjectConfirmButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useDeleteProjects.deleteProjectConfirmButton?c=77zh4em8bhpv", defaultMessage: "{count, plural, one {Delete Project} other {Delete {count} Projects}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Delete project loading toast */
            deleteProjectLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteProjects.deleteProjectLoading?c=1et5wriztusgk", defaultMessage: "Deleting Project\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Delete project confirmation title */
            deleteProjectTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useDeleteProjects.deleteProjectTitle?c=h804avxptsh9", defaultMessage: "{count, plural, one {Delete Project?} other {Delete {count} Projects?}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message with name */
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number, name: string): string => __intl__.intl().formatMessage({ id: "useDeleteProjects.errorMessage?c=2av4oh8oi9fr6", defaultMessage: "{count, plural, one {Failed to delete the Project \"{name}\"} other {Failed to delete {count} Projects}}" }, { count: count, name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Generic error message */
            genericErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteProjects.genericErrorMessage?c=2kk8a2zzsbi91", defaultMessage: "Failed to delete the Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message */
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number, name: string): string => __intl__.intl().formatMessage({ id: "useDeleteProjects.successMessage?c=3jd2e4dbq0zrm", defaultMessage: "{count, plural, one {\"{name}\" Project was deleted} other {{count} Projects and all their files have been deleted}}" }, { count: count, name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
